import React from 'react';
import { Link } from 'react-router-dom';
import ShareButton from './ShareButton';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          <h3>Fatima Zahra Moussaid</h3>
          <p>Un espace pour écrire, partager, documenter et explorer. Merci de visiter.</p>
        </div>
        <div>
          <h3>Explorer</h3>
          <div className="footer-links">
            <Link to="/articles">Articles</Link>
            <Link to="/notes">Notes</Link>
            <Link to="/cards">Cards</Link>
            <Link to="/qcm">QCM</Link>
            <Link to="/plans">Plans</Link>
          </div>
        </div>
        <div>
          <h3>À propos</h3>
          <div className="footer-links">
            <Link to="/about">Qui suis-je</Link>
            <Link to="/cv">CV détaillé</Link>
            <Link to="/login">Admin</Link>
          </div>
        </div>
      </div>
      <div className="footer-share">
        <span>Le blog vous plaît ?</span>
        <ShareButton url="/" title="Zahra's Learning — Fatima-Zahra Moussaid" text="Le blog de Fatima-Zahra : articles, cartes de révision et QCM" label="partager le site" />
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} fatimazahramoussaid.com — made with love & caffeine
      </div>
    </footer>
  );
}
